import './polyfills/resizeObserver';
import './polyfills/matchMedia';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.scss';
import App from './App.tsx';
import './i18n';
import localforage from 'localforage';

localforage.config({
    name: 'MyAuraAppDatabase',
    storeName: 'UserSettings',
    description: 'Stores user session and settings data',
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
